import _ from "lodash";
import { getItem, setItem } from "utils/localstorage";

const defaultPins = ["replication", "cloud-backup", "cloud-compliance", "spot", "cloud-sync", "global-file-cache", "kubernetes"];
const darkDefaultPins = ["replication", "timeline"];

const defaultPinsMap = _.chain(process.env.REACT_APP_IS_DARK === 'true' ? darkDefaultPins : defaultPins).keyBy().mapValues(() => true).value();

const defaultState = () => ({
    pinnedServices: []
});

const buildWorkingEnvironmentEntry = (servicesMap) => {
    return {
        key: "working-environments",
        logo: servicesMap['cloud-volumes-ontap'].logo,
        category: "services",
        "isFeature": true,
        "service": {
            "to": "/working-environments",
            "description": "Review CVO, CVS, ANF & On-Premises",
            "label": "Canvas",
        }
    }
};

const readyHeader = ({resources, services}) => {
    const localStorageItemKey = {itemKey: "userServicePins"};

    const storedPins = getItem(localStorageItemKey);

    const orderMap = storedPins && _.chain(storedPins).map((pin, index) => ({
        key: pin,
        index
    })).keyBy("key").value();

    if(orderMap) {
        orderMap["working-enviroments"] = {
            key: "working-environments",
            index: Number.MIN_VALUE
        }
    }

    const useDefaultPins = !storedPins;
    const pinsMap = useDefaultPins ? defaultPinsMap : _.chain(storedPins).keyBy().mapValues(() => true).value();
    pinsMap["working-environments"] = true;

    resources = resources.map(resource => {
        return {...resource, isPinned: pinsMap[resource.key]};
    });

    services = services.map(service => {
        return {...service, isPinned: pinsMap[service.key]};
    });

    let pinnedServices = _.filter(resources.concat(services), { isPinned: true });

    if(orderMap) {
        pinnedServices = _.sortBy(pinnedServices, (service) => orderMap[service.key].index)
    }

    return {pinnedServices, resources, services};
};

export default (state = defaultState(), { type, payload }) => {
    switch (type) {
        case "MENU:OPEN-WIDGET": {
            return {...state, activeWidget: payload}
        }
        case "MENU:CLOSE-WIDGET": {
            return {...state, activeWidget: null}
        }
        case "MENU:REMOVE-CONNECTOR": {
            const {agentId} = payload;
            return {...state, removeConnector: agentId}
        }
        case "MENU:CANCEL-REMOVE-CONNECTOR": {
            return {...state, removeConnector: null}
        }
        case "MENU:INITIALIZE": {
            const {servicesList, activeFeatures} = payload;
            const servicesMap = _.keyBy(servicesList, "key");

            let filteredServices = servicesList.filter(service => activeFeatures[service.key])

            const services = _.chain(filteredServices).filter(service => !service.service.isResource && !service.service.noMenuItem).sortBy("service.priority").value();
            const resources = [buildWorkingEnvironmentEntry(servicesMap)].concat(_.chain(filteredServices).filter(service => service.service.isResource).sortBy("service.priority").value());
            return {...state, ...readyHeader({resources, services}), totalCount: resources.length + services.length}
        }
        case "MENU:TOGGLE-SERVICE-PIN": {
            const { service, pinned } = payload;
            let services = state.services;
            let resources = state.resources;
            let pinnedServices = state.pinnedServices;
            let selectedService = null;

            const setAndUpdate = (list) => {
                return list.map(entry => {
                    if(entry.key === service) {
                        selectedService = {...entry, isPinned: pinned};
                        return selectedService;
                    } else {
                        return entry;
                    }
                });
            };

            if(service === "timeline" || service === "license-service") {
                resources = setAndUpdate(state.resources)
            } else {
                services = setAndUpdate(state.services);
            }

            if(!pinned) {
                pinnedServices = _.reject(pinnedServices, {key: service})
            } else {
                pinnedServices = pinnedServices.concat([selectedService]);
            }

            const localStorageItemKey = {itemKey: "userServicePins", userId: state.userId};
            const storedPins = _.map(pinnedServices, "key");
            setItem(localStorageItemKey, storedPins);

            return {...state, useDefaultPins: false, services, resources, pinnedServices, changedPins: true}
        }
        case "MENU:OPEN-SLIDER": {
            return {...state, isServicesSliderOpen: true, changedPins: false}
        }
        case "MENU:CLOSE-SLIDER": {
            return {...state, isServicesSliderOpen: false}
        }
        default: {
            return state;
        }
    }
};
